import useGhaiPopLateNightConfigs, {
  IDataType as IGhaiPopLateNightConfigsDataType,
} from './useGhaiPopLateNightConfigs'
import useLocationIntradayConfigs, {
  IDataType as ILocationIntradayConfigsDataType,
} from './useLocationIntradayConfigs'

export type IVariablesType =
  | 'ghaiPopLateNightConfigs'
  | 'ghaiPopLocationIntradayConfigs'

export type IDataType = IGhaiPopLateNightConfigsDataType &
  ILocationIntradayConfigsDataType

export const hooks = [
  ['ghaiPopLateNightConfigs', useGhaiPopLateNightConfigs],
  ['ghaiPopLocationIntradayConfigs', useLocationIntradayConfigs],
] as const
